import { createMessage, SB } from '@play-co/replicant';
import createMessages from './createMessages';
import * as Inventory from '../../inventory';
import { inventoryMessages } from '../../inventory/inventory.messages';
import * as Admin from '../../admin';
import adminMessages from '../../admin/admin.messages';
import giftsMessages from 'src/replicant/gifts/gifts.messages';
import { socialMessages } from 'src/replicant/social/social.messages';
import { visitMessages } from '../../visit/visit.messages';
import { petMessages } from '../../pet/pet.messages';
import duoMessages from 'src/replicant/duo/duo.messages';
import { teamMemberMessages } from 'src/replicant/team/team.messages';
import friendsMessages from 'src/replicant/friends/friends.messages';
import { getDummyAPI } from 'src/replicant/inventory/inventory.utils';
import { cardsMessages } from 'src/replicant/cards/cards.messages';
import { deprecatedMessages } from './deprecatedMessages';
import { buddiesMessages } from 'src/replicant/buddies/buddies.messages';
import { jankenMessages } from 'src/replicant/janken/janken.messages';
export default createMessages({
  ...inventoryMessages,
  ...adminMessages,
  ...giftsMessages,
  ...socialMessages,
  ...visitMessages,
  ...petMessages,
  ...duoMessages,
  ...teamMemberMessages,
  ...friendsMessages,
  ...cardsMessages,
  ...buddiesMessages,
  ...jankenMessages,

  ...deprecatedMessages,

  /**
   * Force re-indexing ES state related computed properties
   * Sent from scheduled messages
   */
  offlineUpdateState: createMessage(SB.object({}), (state, _, info) => {
    state.offlineUpdateAt = info.timestamp;
  }),

  // deprecated messages

  /**
   * @deprecated
   */
  applyAttributeDecay: createMessage(
    SB.object({
      attribute: SB.tuple([
        'stomach',
        'love',
        'dirtiness',
        'urine',
        'toothAcidity',
      ]),
      amount: SB.number(),
    }),
    () => {
      // no-op
    },
  ),

  /**
   * @deprecated
   */
  setStatusEffects: createMessage(
    SB.object({
      asleep: SB.boolean().optional(),
      evolving: SB.boolean().optional(),
      sick: SB.boolean().optional(),
      toothDecay: SB.boolean().optional(),
      scared: SB.boolean().optional(),
    }),
    () => {
      // no-op
    },
  ),

  /**
   * @deprecated
   */
  modifyGems: createMessage(SB.number(), (state, amount) => {
    if (amount >= 0) {
      Inventory.modifiers.addFreeGems(
        state,
        amount,
        { feature: 'message' },
        getDummyAPI(),
      );
    } else {
      Inventory.modifiers.consumeGems(
        state,
        amount,
        { feature: 'message' },
        getDummyAPI(),
      );
    }
  }),
});
